<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page1-2')
              | Estás en: Elige tu Crédito Hipotecario / ¿Estoy listo para cursar esta lección?
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 2 DE 5
            v-card-text.titulo24Reg.text-center
              | La contratación de créditos implica tener cultura y buenas prácticas de administración financiera. La siguiente es una idea preconcebida en la mente de varias personas; te invitamos a revisarla y a responderla a partir de tu experiencia.
            v-card-text.parrafoDestacadoB.text-center  Dada la siguiente afirmación, selecciona la respuesta que consideres correcta.
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | Cuando tienes un crédito, terminas pagando más de lo establecido en el contrato a pesar de realizar tus pagos y no sabes por qué.
              v-layout.py-0.my-0(row, justify-center)
                v-flex(xs8, sm6, md4, offset-xs1, justify-center)
                  v-radio-group(v-model='respuesta ', row)
                    div(v-if='sent && (respuesta==true) ')
                      v-icon(size='15px', color='red ') fas fa-times
                    v-radio.pt-0.px-4(color='primary ', :label='`Cierto` ', :value='true ')
                    div(v-if='sent && (respuesta==false) ')
                      v-icon(size='15px', color='green') fas fa-check
                    v-radio.pt-0.px-4(color='primary ', :label='`Falso` ', :value='false ')
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='respuestaIsNone ', :disabled="respuesta=='none' ", @click='sendResult(respuesta) ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          div(v-if='sent && (respuesta==false) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien!
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  | Comúnmente los casos relacionados con cargos adicionales ocurren porque las personas no cumplen el compromiso de pagar a tiempo los montos para no generar intereses.
                                p.text-sm-left.px-5
                                  | Una cultura financiera basada en el pleno conocimiento de las condiciones contratadas, aunado a pagos adecuados en monto y tiempo, mantendrán siempre al crédito como lo que es, una herramienta conveniente para que adquieras
                                  | bienes y servicios. ¡Tu respuesta es correcta!
                          div(v-if='sent && (respuesta==true) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  b
                                    | ¿Sabías que los bancos están obligados a cumplir las condiciones de los contratos, y es garantía que mientras pagues en tiempo y cantidades establecidas, nunca te cobrarán cargos adicionales?
                                p.text-sm-left.px-5
                                  | El conocimiento de las condiciones contratadas aunado a pagos adecuados en monto y tiempo, mantendrán siempre al crédito como lo que es, una herramienta conveniente para que adquieras bienes y servicios.
                                p.text-sm-left.px-5
                                  | Es falsa la idea de que con un crédito siempre terminas pagando más de lo contratado.
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page1-4') ")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      dialog: false,
      correcta: false,
      respuesta: 'none',
      sent: false,
      resultado: 0,
    }
  },
  methods: {
    sendResult() {
      if (this.correcta == this.respuesta) {
        this.resultado = 1;
      }
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('send_page_state', this.respuesta);
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  created() {
    if ('suspend_data'in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.respuesta = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    respuestaIsNone() {
      return {
        'btn-primary': this.respuesta != 'none',
        'btn-secondary': this.respuesta == 'none'
      }
    }
  }
};
</script>
